import { render, staticRenderFns } from "./InputTicketsEvento.vue?vue&type=template&id=7b42ceae&scoped=true"
import script from "./InputTicketsEvento.vue?vue&type=script&lang=js"
export * from "./InputTicketsEvento.vue?vue&type=script&lang=js"
import style0 from "./InputTicketsEvento.vue?vue&type=style&index=0&id=7b42ceae&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b42ceae",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/cleverton/paytour-payt-1708/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7b42ceae')) {
      api.createRecord('7b42ceae', component.options)
    } else {
      api.reload('7b42ceae', component.options)
    }
    module.hot.accept("./InputTicketsEvento.vue?vue&type=template&id=7b42ceae&scoped=true", function () {
      api.rerender('7b42ceae', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "js/apps/calendario_venda/components-evento/InputTicketsEvento.vue"
export default component.exports